import React from 'react';

import { ExecutionStatusLozenge } from '@qality/common-components/src/atoms/ExecutionStatusLozenge';
import { ReportStatusCell } from '@qality/common-model';

type Props = {
  cell: ReportStatusCell;
};

export default function ReportExecutionStatus({ cell }: Props): JSX.Element {
  return <ExecutionStatusLozenge status={cell} />;
}
